const FRAME_OPTIONS = [
  { id: 'black', label: 'Black' },
  { id: 'white', label: 'White' },
  { id: 'none', label: 'No Frame' },
];

const MUSEUM_LABEL_OPTIONS = [
  { id: 'white', labelKey: 'museum_label_options.white', price: 20 },
  { id: 'none', labelKey: 'museum_label_options.none', price: 0 },
];

function buildLabelMap(optionList) {
  return optionList.reduce((accumulator, option) => {
    accumulator[option.id] = option.label;
    return accumulator;
  }, {});
}

const FRAME_OPTION_LABELS = buildLabelMap(FRAME_OPTIONS);
const MUSEUM_LABEL_OPTIONS_BY_ID = new Map(MUSEUM_LABEL_OPTIONS.map((option) => [option.id, option]));

function getMuseumLabelPrice(optionId) {
  return MUSEUM_LABEL_OPTIONS_BY_ID.get(optionId)?.price ?? 0;
}

export {
  FRAME_OPTIONS,
  FRAME_OPTION_LABELS,
  getMuseumLabelPrice,
  MUSEUM_LABEL_OPTIONS,
  MUSEUM_LABEL_OPTIONS_BY_ID,
};
